import { render, staticRenderFns } from "./Pg13.vue?vue&type=template&id=03e12412&scoped=true&lang=pug&"
import script from "./Pg13.vue?vue&type=script&lang=ts&"
export * from "./Pg13.vue?vue&type=script&lang=ts&"
import style0 from "./Pg13.vue?vue&type=style&index=0&id=03e12412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e12412",
  null
  
)

export default component.exports